export enum SetupAppName {
    CALL_CENTER = "call_center",
}